import { type AiBuilderMessage } from '../stores/types';
import { type AiBuilderChatCopy } from '../utils/aiBuilderChatCopy';

export type AiBuilderSourcePreparationProgressMessage = Extract<
  AiBuilderMessage,
  { kind: 'progress' }
>;

export const createSourcePreparationProgressId = (runId: number) =>
  `source-preparation-${runId}`;

export const createSourcePreparationProgressMessage = (
  runId: number,
  copy: AiBuilderChatCopy,
): AiBuilderSourcePreparationProgressMessage => ({
  id: createSourcePreparationProgressId(runId),
  kind: 'progress',
  title: copy.sourcePreparation.runningTitle,
  status: 'running',
  steps: [
    {
      id: 'read-source',
      label: copy.sourcePreparation.readSourceRunning,
      status: 'running',
    },
    {
      id: 'prepare-generation',
      label: copy.sourcePreparation.prepareGenerationPending,
      status: 'pending',
    },
  ],
});

export const createFailedSourcePreparationProgressMessage = (
  runId: number,
  copy: AiBuilderChatCopy,
): AiBuilderSourcePreparationProgressMessage => ({
  id: createSourcePreparationProgressId(runId),
  kind: 'progress',
  title: copy.sourcePreparation.failedTitle,
  status: 'stopped',
  steps: [
    {
      id: 'read-source',
      label: copy.sourcePreparation.readSourceFailed,
      status: 'stopped',
    },
    {
      id: 'prepare-generation',
      label: copy.sourcePreparation.prepareGenerationFailed,
      status: 'stopped',
    },
  ],
});
